import { render, staticRenderFns } from "./Prenotazioni.vue?vue&type=template&id=b42cfd54&"
import script from "./Prenotazioni.vue?vue&type=script&lang=js&"
export * from "./Prenotazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports